import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "xy-wrap" }

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'fwxy',
  setup(__props) {

const text = ref(`
特别提示您在使用万川AI新媒体软件及服务前，请确保本人已经完全理解并接受本协议所有条款尤其是免责和责任限制条款，否则，请不要注册、登录或使用。一旦您注册、登录或使用，则表明您已经完全理解并接受本协议所有条款，尤其是免责和责任限制条款、法律适用和争议解决条款。其中免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。如您未满18周岁，请在监护人陪同下仔细阅读并充分理解本协议，并征得监护人的同意后使用万川AI新媒体软件及相关服务。
        本协议更新日期2024-06-03
        一、接受协议
        1.1 本服务协议（以下简称“本协议”）是由您（以下也简称“用户”）与广东省灵泽万川人工智能科技有限公司（以下简称“万川公司”）就万川AI新媒体软件（以下简称“本软件”）提供的音视频制作、下载服务所共同缔结的、对双方具有约束力的有效契约。
        1.2 您确认：一旦您注册成为万川AI新媒体的用户或者使用万川AI新媒体软件或服务，便表示您已经完全理解并同意接受本协议。如您未满18周岁，请在监护人陪同下仔细阅读并充分理解本协议，并征得监护人的同意后使用万川AI新媒体软件及相关服务。
        1.3 您确认：万川公司可自行全权决定更改“本协议”及相应的服务规则内容。如“本协议”及相应的服务规则内容有任何变更，万川公司将在应用首页上刊载公告，通知用户，而无需另行单独通知您。如用户不同意相关变更，有权立即停止使用本软件及服务；如果用户继续使用本软件及服务，则表示已无条件接受经修订的协议。经修订的协议一经在万川公司公布后，立即自动生效。
        1.4 本协议（包括修订后的版本）、万川AI新媒体隐私政策和与万川AI新媒体软件使用的第三方软件或技术相关的协议或其他文件（若有）等，共同构成了万川AI新媒体软件及服务的完整协议，对用户及万川公司均具有法律约束力。
1.5 需特别说明的是，本服务可能整合于万川公司或万川公司以外的第三方提供的服务，您应仔细识别实际服务提供方，并向其主张权利和责任。万川公司将依据法律法规要求履行相应的义务和责任，除此之外，万川公司将不会对该等第三方的行为承担其他义务或责任。
        二、服务内容及软件形式
        2.1 服务内容
        万川AI新媒体是一个向广大用户提供音视频制作、下载、充值付费和交易的平台，除非另有明确规定，增强或强化目前服务的任何新功能，包括新产品以及新增加的服务，均无条件地适用本协议。
        2.2 软件形式
        （1）用户可能可以通过电脑、手机等终端以网页、客户端等形式使用本软件，具体以万川公司提供的为准，同时，万川公司会不断丰富本软件的终端、形式等。当用户使用本软件时，用户应选择与用户的终端、系统等相匹配的软件版本，否则，用户可能无法正常使用本软件。若您并非从万川公司或经万川公司授权的第三方获取本服务的，万川公司无法保证非官方版本的万川AI新媒体软件及服务能够正常使用，您因此遭受的损失与万川公司无关。
        （2）为了改善用户体验、完善服务内容，保证本软件及服务的安全性和功能的一致性等目的，万川公司将不断努力开发新的服务，并有权对本软件进行更新（这些更新可能会采取包括但不限于软件替换、修改、功能强化、版本升级等形式），或者对本软件的部分功能效果进行改变或限制，或者终止或中止本软件及相关服务。本软件新版本发布后，万川公司不保证旧版软件继续可用及相应的客户服务，请随时核对并下载最新版本。用户充分理解并同意，万川公司拥有上述权利，并可以在不向用户特别通知的情况下行使该权利。
        2.3 用户充分理解并同意，万川AI新媒体仅向广大用户提供声音/形象定制、音视频制作、下载，充值付费和交易的平台服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负责。
        三、用户使用规则
        3.1 账户注册与使用
        （1）注册账号。用户确认，在进行注册程序或以其他万川公司允许的方式实际使用万川公司提供的服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述相适应的民事行为能力，请经过您的监护人同意并由您的监护人代理注册，否则您及您的监护人应依照法律规定承担因此而导致的一切后果。您注册成功后，本软件将给予您一个用户账号及相应的密码，该用户账号的所有权归万川公司所有，您仅可以获得该用户账号的使用权，您不得赠与、借用、租用、转让或售卖账号或者以其他方式许可他人使用账号。您应当妥善保管该用户账号和密码，通过该用户账号而发生的一切行为均视为您本人的行为，您应当对该用户账号项下进行的所有活动和事件以及因此而产生的一切后果负法律责任。
        （2）用户承诺，在注册时及使用万川公司提供的服务过程中所提供的一切信息和数据（合称“信息”）均真实准确，且将及时维护和更新信息，特别是提供的联系电话、联系地址、手机号码等联系方式，以便万川公司与用户进行有效联系；用户的信息有需要更新的，用户应按本软件的要求或提示进行更新操作。因用户提供的信息不真实、不准确、未更新或通过信息无法与用户取得联系的，由用户自行承担因此而造成的一切后果，包括导致用户在使用万川公司提供的服务过程中产生任何损失或增加费用的，也应由用户完全独自承担。您了解并同意，您有义务保持您提供的联系方式的有效性，如有变更需要更新的，您应按万川公司的要求进行操作。
        （3）如果用户发现账号遭他人非法使用，应立即通知万川公司，要求万川公司暂停相关服务。互联网上不排除因黑客行为或用户的保管疏忽导致用户账号、密码遭他人非法使用，用户充分理解并同意，此类情况与万川公司无关，万川公司不对此类情况的发生承担任何责任。对于因用户未能保持信息安全和保密而在用户账户下发生的任何行为，用户应当承担全部责任；如果因此导致万川公司或本软件的任何其他用户或访问者遭受损失，用户应当对该等损失承担赔偿责任。
        （4）如果单个IP或账号合成调用次数过多，或单个IP或账号调用频次过高，容易造成万川AI新媒体网络服务卡死、排队等问题，因此为了保障服务稳定及资源的合理分配，您充分理解并同意，万川公司会对单个IP地址、单个账号一定时间内的合成调用次数（含试听）进行合理控制，原则上单个IP或账号合成调用次数不得超过4000次/天。如果您因特殊情况需要调用更高次数的服务，请与我们联系；但如果您在未经万川公司事先书面同意的情况下，采取任何途径规避次数控制的，万川公司有权根据自己的判断立即禁用您的IP或取消对您服务而不对您承担任何责任。
        （5）用户可以随时注销此前注册的账号。在用户注销账号后，万川公司将停止提供依赖账号登录的产品和服务，并依据用户的需求，除法律法规另有规定外，万川公司将删除或匿名化处理用户的个人信息。因此，用户理解并同意，注销账号的行为是不可逆的行为，在用户注销账户后，万川公司将无法恢复该账户的任何相关信息。
        3.2 根据相关法律法规，万川公司在此郑重提请用户注意，任何经由我们的服务以上载、张贴、发送电子邮件或任何其它方式传送的资讯、资料、文字、软件、音乐、音频、照片、图形、视频、信息或其它资料（以下简称“内容”），无论系公开发布还是私下传送，均由内容提供者、上传者承担责任。万川公司无法控制经由我们的服务传送之内容，因此不保证内容的正确性、完整性或品质。用户已预知使用我们的服务时，可能会接触到令人不快、不适或令人厌恶之内容。在任何情况下，万川公司均不为任何内容负责，包含但不限于任何内容之任何错误或遗漏，以及经由我们的服务以张贴、发送电子邮件或其它方式传送任何内容而衍生之任何损失或损害。但万川公司有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用我们的服务的全部或部分，保存有关记录，并向有关机关报告。
        3.3 用户在万川AI新媒体制作或发布信息（包括但不限于声音和形象模型、视频/音频作品内容、注册用户名、图像、评论等）时，必须遵守国家有关法律规定，并承担一切因自己发布信息不当导致的民事、行政和刑事等法律责任。用户在万川AI新媒体所制作或发布的信息（包括用户不限于配音作品内容、注册用户名、图像、评论等），不得含有以下任何内容：
（1）违反宪法确定的基本原则的；
（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； 
（3）损害国家荣誉和利益，攻击党和政府的；
（4）煽动民族仇恨、民族歧视，破坏民族团结的；
（5）破坏国家、地区间友好关系的； 
（6）违背中华民族传统美德、社会公德、论理道德、以及社会主义精神文明的； 
（7）破坏国家宗教政策，宣扬邪教和封建迷信的； 
（8）散布谣言或不实消息，扰乱社会秩序 ，破坏社会稳定的； 
（9）煽动、组织、教唆恐怖活动、非法集会、结社、游行、示威、聚众扰乱社会秩序的； 
（10）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的； 
（11）侮辱或诽谤他人，侵害他人合法权益的； 
（12）侵犯他人肖像权、姓名权、名誉权、隐私权或其他人身权利的； 
（13）使用漫骂、辱骂、中伤、恐吓、诅咒等不文明语言的； 
（14）以非法民间组织名义活动的； 
（15）侵犯他人著作权、信息网络传播权等合法权益的； 
（16）含有法律、行政法规禁止的其他内容的。 
        3.4 除非法律允许或万川公司事先书面同意，用户在使用本软件及服务过程中不得从事下列行为，也不得为以下行为提供便利（包括但不限于为其他用户的行为提供便利等）：
        （1） 删除、隐匿、改变本软件及其副本上关于著作权、专利、商标的任何信息；
        （2） 对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；
        （3） 恶意刷单或非法攻击或以任何其他方式干扰或者企图干扰万川AI新媒体网络服务，对万川AI新媒体产品稳定性造成威胁；
        （4） 对万川公司或关联公司拥有知识产权的内容进行包括但不限于使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
        （5） 对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非万川公司经授权的第三方工具/服务接入本软件和相关系统；
        （6） 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
        （7） 通过非万川公司开发、授权的第三方软件、插件、外挂、系统，登录或使用万川公司软件及服务，或制作、发布、传播上述工具；
        （8） 自行或者授权他人、第三方软件对本软件及其组件、模块、数据等进行干扰；
        （9） 其他未经万川公司事先书面授权的行为。
        3.5 用户在万川AI新媒体制作或发布信息（包括但不限于声音和形象模型、视频/音频作品内容、注册用户名、图像、评论等）时，必须遵守国家有关法律规定，并承担一切因自己发布信息不当导致的民事、行政和刑事等法律责任。用户在万川AI新媒体所制作或发布的信息（包括用户不限于配音作品内容、注册用户名、图像、评论等），不得含有以下任何内容：
        （1）违反宪法确定的基本原则的；
        （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； 
        （3）损害国家荣誉和利益，攻击党和政府的；
        （4）煽动民族仇恨、民族歧视，破坏民族团结的；
        （5）破坏国家、地区间友好关系的； 
        （6）违背中华民族传统美德、社会公德、伦理道德、以及社会主义精神文明的； 
        （7）破坏国家宗教政策，宣扬邪教和封建迷信的； 
        （8）散布谣言或不实消息，扰乱社会秩序 ，破坏社会稳定的； 
        （9）煽动、组织、教唆恐怖活动、非法集会、结社、游行、示威、聚众扰乱社会秩序的； 
        （10）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的； 
        （11）侮辱或诽谤他人，侵害他人合法权益的； 
        （12）侵犯他人肖像权、姓名权、名誉权、隐私权或其他人身权利的； 
        （13）使用谩骂、辱骂、中伤、恐吓、诅咒等不文明语言的； 
        （14）以非法民间组织名义活动的； 
        （15）侵犯他人著作权、信息网络传播权等合法权益的； 
        （16）法律、行政法规禁止的其他内容的。 
        四、保密及隐私保护
        4.1 除本协议另有约定或法律法规规定的情况外，未经用户的同意，万川公司不会向第三方公开或传播用户的信息、制作与发布的数字人内容等，万川公司将采取严格的保密措施保护用户的信息不被未经授权的访问、使用或泄漏。
        4.2 用户理解并同意，若非万川公司原因，如因不可抗力、盗窃、抢劫、黑客攻击等造成信息泄露的，万川公司不承担任何法律责任。
        4.3 万川公司在下述情况下不再承担保密义务：
        （1）因非万川公司原因，用户提供的信息、语音及文字稿件被公开的；
        （2）法律法规要求、行政司法机关要求、或其他有权机关要求披露的；
        （3）事先获得用户的授权；
        （4）为查找、预防或处理欺诈、安全或技术方面的问题；
        （5）为执行相关服务协议或本协议、维护社会公共利益；
        （6）为保护万川公司的客户、万川公司或万川公司的关联公司、其他用户或雇员的人身财产安全或其他合法权益等合理且必要的用途。
        4.4 一旦用户选择使用本服务，即表示用户认可并接受与本服务相关的隐私政策的内容以及万川公司可能随时更新并公布的新版本的隐私政策。
        五、关于注册用户在万川AI新媒体制作的作品和内容
        5.1 用户制作的作品和内容是指用户在万川AI新媒体上制作的声音/形象模型、音频、视频或其它任何形式的内容包括但不限于文字、图片、链接等。
        5.2 用户在万川AI新媒体制作原创作品及转载作品的，用户保证其对该等作品及制作所需提供的素材，包括但不限于文字内容、背景音频、音乐、图片、链接等，享有合法著作权或者相应授权，万川公司不承担由此导致的一切责任。如用户违反上述承诺，将独立承担一切责任及赔偿给万川公司造成的全部损失。（损失范围包括但不限于万川公司由此增加的经营成本、由此须向第三方支付的赔偿金等和维权费用，维权费用包括但不限于万川公司为此支出的诉讼费、仲裁费、财产保全费、财产保全责任保险费、律师费、公证费、公告费、差旅费、交通费等。）
        5.3 因用户进行上述作品和内容在万川AI新媒体的制作或发布而导致任何第三方提出索赔要求或衍生的任何损害或损失，由用户承担全部责任。
        5.4 用户使用本软件及服务将图片、文字、音频等信息公开发布、传播、分享的行为代表了用户有权且同意在全世界范围内，永久性的、不可撤销的、免费的将下列权利授予万川公司：对该信息行使使用、发布、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示等权利；将信息的全部或部分编入其他任何形式的作品、媒体、技术中的权利；对用户的上传、发布信息进行商业开发的权利；通过有线或无线网络向用户的计算机终端、移动通讯终端（包括但不限于便携式通讯设备如手机和智能平板电脑等）等提供信息的下载、点播、数据传输及其相关的宣传和推广等服务的权利。
        六、知识产权
        6.1本软件相关著作权及其他相关权利（包括但不限于本软件所包含的所有文字、图表、用户界面、可视界面、图片、商标、标识、声音、音乐、美术作品及计算机编码，包括与前述内容相关的设计、结构、选择、协调、表达、“界面外观”及排序等）属于万川公司所有，受版权、商标和/或其它财产所有权法律的保护。任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用。否则，万川公司将依法追究法律责任。
        6.2 万川公司不就本软件的适用性及符合用户使用目的承担任何保证或承诺，亦不对本软件及本软件所包含的任何文本、图形、音频和/或视频等资料产生或在传送或递交全部或部分资料过程中产生的延误、不准确、错误和遗漏或由此产生的任何损害赔偿，以任何形式向用户或任何第三方负法律责任。
        6.3在用户遵守本协议的情况下，万川公司即授予用户一项个人、非排他性、不可转让、有限的权利以使用本软件。用户可以在用户自己所有的终端设备上安装、使用、显示、运行许可本软件。但未经万川公司事先明确书面同意，用户不得为出版或发行或为任何其他商业目的以任何方式将本软件的任何部分及任何内容复制、再制、重印、上传、发布、公开展示、编码、翻译、传输或散布至任何其他计算机、服务器、软件或其他媒介。
        6.4 本协议未事先明示授权的其他一切权利仍由万川公司所有，用户在行使这些权利时须应另外取得万川公司的书面许可。万川公司如果未行使前述任何权利，并不构成对该权利的放弃。
        七、广告
        7.1 用户了解并同意在使用本软件及服务的过程中，万川公司会向用户发出的其他产品的推广消息，包括但不限于商品促销等推广信息，对因此有可能给用户造成的打扰，请予以充分理解。
        7.2 万川公司依照法律的规定及相关合作协议对广告商履行相关义务，但用户应当自行判断广告信息的真实性并为自己的判断行为负责，除法律明确规定外，用户因依该广告信息进行的交易或因前述广告商提供的内容而遭受的损失或损害，万川公司不承担任何责任。
        7.3 用户同意，对本产品或服务中出现的广告信息，用户应审慎判断其真实性和可靠性，除法律明确规定外，用户应对依该广告信息进行的交易负责。
        八、第三方产品和服务 
8.1 用户在本软件中使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的协议及相关规则。如因第三方软件及相关服务产生的争议、损失或损害，由您自行与第三方解决，万川公司并不就此而对您或任何第三方承担任何责任。
8.2 因用户使用本产品万川AI新媒体或要求万川公司提供特定服务时，本产品可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供（包括但不限于第三方通过本软件插件提供的服务），万川公司不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与万川公司无关，万川公司不承担任何责任。
        九、免责声明 
9.1 用户明确同意其使用万川AI新媒体所存在的风险将完全由其本人承担；因其使用万川AI新媒体而产生的一切后果也由其本人承担，万川公司对用户及任何第三方不承担任何责任。 
9.2 万川公司不担保或保证网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作任何担保或保证。
 9.3 万川公司不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由万川公司实际控制的任何网页上的内容，万川公司也不承担任何责任。 
9.4 对于因不可抗力或万川公司不能控制的原因造成的网络服务中断或其它缺陷，万川公司不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。 
9.5 万川公司对于任何自万川公司而获得的他人的信息、内容或者广告宣传等任何资讯（以下统称“信息”），不保证真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，须自行甄别真伪和谨慎预防风险。否则，无论何种原因，万川公司不对任何非与万川公司直接发生的交易和/或行为承担任何直接、间接、附带或衍生的损失和责任。
 9.6 用户理解并同意，对于万川公司向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，万川公司无需承担任何责任： 
（1）万川公司向用户免费提供的各项网络服务； 
（2）万川公司向用户赠送的任何产品或者服务；
（3）万川公司向收费网络服务用户附赠的各种产品或者服务；
（4）用户资料遭到未授权的使用或修改；
（5）其他与万川AI新媒体相关的事宜。
        十、责任限制
        用户明确理解并同意，基于以下原因导致的包括但不限于利润、信誉、应用程序、数据损失或其他无形损失，万川公司不承担任何直接、间接、附带、特殊、衍生或惩罚性赔偿责任（即使万川公司事先已被告知可能发生此种赔偿）:
        （1） 使用或无法使用我们的服务；
        （2） 为替换从或通过我们的服务购买或取得之任何商品、数据、信息、服务，收到的讯息，或缔结之交易而发生的成本； 
        （3） 用户传输的数据遭到未经授权的访问或篡改；
        （4） 任何第三方在我们服务中的陈述或行为，或与我们服务相关的其他事项，但本协议有明确规定的除外。
        十一、服务的修改或终止
        万川公司有权在任何时候单方临时或永久修改或终止我们的服务（或其任何部分），无论是否事先通知。用户同意，对于我们服务的任何修改、暂停或终止，万川公司不对用户或任何第三方承担任何责任。
        十二、终止服务及违约处理
        12.1 用户充分理解并同意，如果万川公司发现或收到他人举报或投诉用户违反相关法律法规或本协议约定，万川公司有权根据用户行为的性质自行决定且无需提前通知，采取包括但不限于暂停或终止本服务、追究法律责任、索赔全部损失等措施。用户理解，对本协议的任何违反均可能对万川公司造成无法弥补的损害（金钱赔偿无法充分弥补该等损害），并同意万川公司在该等情况下获得其认为必要或适当的任何禁令救济或等同救济。此等救济是对万川公司根据法律享有的任何其他救济的补充。
        12.2 用户同意，万川公司可自行决定且无需提前通知，因下列原因终止用户访问本软件的权限，包括但不限于：
        （1） 应政府部门和司法机关或其他有权机关的要求；
        （2） 本软件或本软件提供的任何服务的中止或重大修改；
        （3） 事先不可预见的技术问题。
        12.3 用户充分理解并同意，万川公司有权依据合理判断对违反相关法律法规或本协议规定的行为进行处理，对用户的违法违规行为采取适当的法律行动及措施，并根据法律法规保存相关信息向有关部门报告等，用户应独自承担由此产生的一切法律责任。
        12.4 对于行政机关、司法机关或任何第三方向万川公司提出的，因用户违反法律法规或本协议之约定使用本软件而产生的或与之相关的任何处罚、判决、调解、请求、损失、责任、主张或费用（包括但不限于处罚款、赔偿款、补偿款、律师费、诉讼费、鉴定费、差旅费、执行费等），用户同意赔偿万川公司及其管理人员、董事、股东、前任、继承人、员工、代理人、子公司和关联公司由此遭受的全部损失。
        12.5 用户充分理解并同意，万川公司根据上述救济途径而对用户采取的措施均不会导致万川公司对用户承担任何违约或任何其他可能导致的责任。在万川公司选择终止本协议或停止服务后，万川公司没有义务为用户保留原账号中或与之相关的任何信息。 
十三、法律管辖与适用
        13.1 本服务协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。
        13.2 如就本协议内容或其执行发生任何争议，万川公司与用户双方应尽量友好协商解决；协商不成时，则争议各方均一致同意将争议提交万川公司所在地人民法院诉讼解决。
        十四、其他
        14.1 用户在使用万川AI新媒体过程中有任何咨询、意见或建议，可通过万川AI新媒体内内置的联系方式提出，万川公司团队将向您及时作出反馈，但解答的义务不应超过万川公司的合理承受限度。您同时应保证您的联系方式畅通，以接收来自万川公司发出的电话或信息，万川公司不对您未收到通知而引起的任何损失承担责任。
        14.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
        14.3 本软件及服务仅限于在中国大陆地区使用，如用户擅自在中国大陆以外地区使用，万川公司不承担因此而产生的任何责任。
        14.4 本协议自用户同意勾选或网上签署并成功注册成为万川AI新媒体用户或实际使用万川AI新媒体软件或服务之日起生效，除非万川公司终止本协议或者用户丧失万川AI新媒体的用户资格，否则本协议始终有效。本协议终止并不免除用户根据本协议或其他有关协议、规则所应承担的义务和责任。
14.5本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。
14.6您和万川公司均是独立的主体，在任何情况下本协议不构成公司对您的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。
        14.7本协议最终解释权归万川公司所有。

`)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { style: {"text-align":"center","color":"#ccc"} }, "万川AI新媒体平台服务协议", -1)),
    _createVNode(_component_el_input, {
      type: "textarea",
      modelValue: text.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
      rows: 30,
      readonly: ""
    }, null, 8, ["modelValue"])
  ]))
}
}

})